import { Box } from "@chakra-ui/react/box";
import { IconButton } from "@chakra-ui/react/button";
import { Circle } from "@chakra-ui/react/circle";
import { Float } from "@chakra-ui/react/float";

import { MenuContent, MenuRoot, MenuTrigger } from "components/ui/menu";
import React, { ReactNode } from "react";

interface FooterNestedNavLinksProps {
  children: ReactNode; // MobileNavButton
  hasNotifications?: boolean;
  mainIcon: any;
}

const FooterNestedNavLinks = ({
  children,
  mainIcon,
  hasNotifications = false,
}: FooterNestedNavLinksProps) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild={true}>
        <IconButton unstyled={true} position="relative" aria-label="Open menu">
          {mainIcon}
          {hasNotifications ? (
            <Float>
              <Circle
                zIndex="1"
                height="1rem"
                width="1rem"
                bgColor="red.solid"
              />
            </Float>
          ) : null}
        </IconButton>
      </MenuTrigger>
      <MenuContent zIndex={999999} opacity={1}>
        {children}
      </MenuContent>
    </MenuRoot>
  );
};

export default FooterNestedNavLinks;
